const transferStatus = Object.freeze({
  complete: 'COMPLETE',
  requested: 'REQUESTED',
  clientComplete: 'CLIENT_COMPLETE',
  cancel: 'CANCEL',
  liquidation: 'LIQUIDATION',
});

export default transferStatus;
